// @flow

// This implements user re-engagement with apps as described in
// https://tvsmiles.atlassian.net/wiki/spaces/TVS/pages/246972449/Re-Engagement+2.0+for+new+Apps.
//
// Testable on http://localhost:3000/labs/reengagement/all.
//
// The app has to provide infos about installations as JSON.


import * as React from 'react';
import styled from 'styled-components';
import CampaignOverview from './CampaignOverview';
import type { Campaign } from '../lib/Campaign';
import type { Reengagement } from '../lib/Reengagement';
import type { Environment } from '../lib/getEnvironment';
import sendJIEvent from '../lib/kwizzad-ji';
import { t } from '../lib/i18n';

function getReengagementsFromNativeApp(): ?Reengagement[] {
    // This is stub data. To show real data, remove this and uncomment the part below it.
    return [
        {
            challengeId: 0,
            campaignId: 1750016423,
            callbackTimestamp: '2018-01-15T10:35:49.706Z',
            installationTimestamp: '2018-01-14T10:32:49.706Z',
            pastStepsFlags: [true, false],
            appPackage: 'de.something.foo',
        },
        {
            challengeId: 0,
            campaignId: 1750016423,
            callbackTimestamp: '2018-01-16T10:35:49.706Z',
            installationTimestamp: '2018-01-16T10:32:49.706Z',
            pastStepsFlags: [true, false],
            appPackage: 'de.something.foo',
        }
    ];

    // if (window.kwizzadData) {
    //     return window.kwizzadData.reengagements;
    // }
    // if (window.KwizzAdJI && typeof window.KwizzAdJI.getReengagements === 'function') {
    //     const reengagementsJSON = window.KwizzAdJI.getReengagements();
    //     console.log('Got reengagement information from native app.');
    //     return JSON.parse(reengagementsJSON);
    // }
    // return null;
}

type Props = {
    params: {
        resourceValue: string,
        environment: Environment,
    },
    className: string;
};

type State = {
    campaigns: Campaign[],
    reengagements: Reengagement[],
    error: ?any,
}


class ReengagementOverview extends React.Component<Props, State> {
    state = {
        campaigns: [],
        reengagements: [],
        error: null,
    };

    async componentWillMount() {
        const reengagements = getReengagementsFromNativeApp();
        if (reengagements) {
            this.setState({ reengagements });
            const campaignIds = reengagements.map(r => r.campaignId).map(String);
            return await this.fetchCampaigns(campaignIds);
        } else {
            this.setState({ error: 'Could not load reengagements from native app.' });
        }
    }

    fetchCampaigns(ids: string[]): Promise<void> {
        const { backendBaseURL } = this.props.params.environment;

        const promises = ids
            .map(id => `${backendBaseURL}/api/campaigns/${id}`)
            .map(url => fetch(url).then(
                (response) => response.json(),
                console.log,
            ));

        return Promise.all(promises)
            .then(
                (campaigns: any) => this.setState({ campaigns }),
                (reason: any) => this.setState({ error: reason }),
            )
            .catch(error => this.setState({ error }));
    }

    reengagementForCampaignId(campaignId: number): ?Reengagement {
        return this.state.reengagements.find(reengagement => reengagement.campaignId === campaignId);
    }

    render() {
        if (this.state.error) {
            return <section className={this.props.className}>{t('genericError')}</section>;
        }

        return (<section className={this.props.className}>
            <header>
                <button className='close-button' aria-label="Close" onClick={sendJIEvent('close')}>
                    <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1">
                        <polygon points="22.7313437 5.61343139 26.7934337 5.61343139 14.2686563 19.5768656 26.7934337 34.3865686 22.7313437 34.3865686 10.2065663 19.5768656" />
                    </svg>
                </button>
                <h1>{t('reengagement.headerTitle')}</h1>
            </header>
            <section className="scrollable-content">
                <ul className="campaigns">
                    {this.state.campaigns.map(campaign => <CampaignOverview
                        key={campaign.id}
                        campaign={campaign}
                        reengagement={this.reengagementForCampaignId(campaign.id)}
                    />)}
                </ul>
            </section>
        </section>);
    }
}

export default styled(ReengagementOverview)`
    color: #111;
    height: 100%;
    width: 100%;
    background-color: #666;
    display: flex;
    flex-direction: column;

    > header {
        height: 50px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background: #444;

        .close-button {
            background-color: transparent;
            border: none;

            width: 50px;
            height: 50px;
            svg {
                polygon {
                    fill: white;
                }
            }
        }

        h1 {
            flex: 1;
            font-size: 1rem;
            color: white;
        }
    }

    > section.scrollable-content {
        flex: 1;
        padding: 10px;
        overflow: scroll;

        display: flex;
        flex-direction: column;
        align-items: center;

        > * {
            width: 100%;
            max-width: 500px;
        }

        ul.campaigns > li:not(:last-child) {
            margin-bottom: 20px;
        }
    }
`;


// WEBPACK FOOTER //
// ./src/Reengagement/ReengagementOverview.jsx